import addGeometryAndNamedValuesState from "utils/addGeometryAndNamedValuesState";
// import getFieldDomain from "utils/getDomain";

export default async function getEsriDataFromLayer({
  view,
  neededDomains,
  query,
  outFields,
  orderByFields,
  returnDistinctValues,
  returnGeometry,
  featureLayer,
  restQueryParams = {},
}) {
  let domains;
  const domainsObject = {};

  const serverFeatureLayerQuery = await featureLayer.queryFeatures({
    where: query || `1=1`,
    outFields: outFields || "*",
    returnGeometry: returnGeometry || false,
    outSpatialReference: view?.spatialReference,
    orderByFields: orderByFields || null,
    returnDistinctValues: returnDistinctValues || false,
    ...restQueryParams,
  });

  if (neededDomains?.length) {
    domains = neededDomains?.map(
      (name) =>
        featureLayer.sourceJSON.fields.find((item) => item.name === name).domain
          .codedValues
    );
    if (neededDomains) {
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < neededDomains?.length; index++) {
        domainsObject[neededDomains[index]] = domains[index];
      }
    }
  }

  const { fields } = featureLayer.sourceJSON;

  const res = addGeometryAndNamedValuesState(
    serverFeatureLayerQuery.features,
    domainsObject
  );
  return {
    domains: domainsObject,
    fields,
    res,
    // serverFeatureLayer,
    serverFeatureLayerQuery,
  };
}
